import { reactive, watch } from 'vue';

/**
 * Estado de layout da casca do admin, compartilhado entre `NavBarLeftAdmin`,
 * `HeaderPage` e `AdminPage`.
 *
 * É um módulo reativo (e não um store Pinia) de propósito: só guarda
 * preferência de interface — nada de negócio, nada que precise de
 * persistência entre sessões além do "recolhida", que fica no localStorage.
 */

const CHAVE_RECOLHIDA = 'admin-sidebar-collapsed';

/** Mesmo ponto de quebra do CSS (`@media (max-width: 991.98px)` em admin.css). */
const MEDIA_MOBILE = '(max-width: 991.98px)';

function lerRecolhida(): boolean {
    try {
        return localStorage.getItem(CHAVE_RECOLHIDA) === '1';
    } catch {
        return false;
    }
}

const mediaMobile = typeof window !== 'undefined' && window.matchMedia
    ? window.matchMedia(MEDIA_MOBILE)
    : null;

export const adminLayoutState = reactive({
    /** Gaveta aberta (só faz efeito abaixo de 992px). */
    mobileOpen: false,
    /** Lateral recolhida em ícones (preferência; só vale no desktop). */
    collapsed: lerRecolhida(),
    /** Viewport abaixo de 992px: a lateral vira gaveta e "recolhida" é ignorado. */
    isMobile: mediaMobile?.matches ?? false,
});

mediaMobile?.addEventListener('change', (e) => {
    adminLayoutState.isMobile = e.matches;
    // Ao voltar para o desktop a gaveta não existe mais; não pode ficar "aberta".
    if (!e.matches) adminLayoutState.mobileOpen = false;
});

watch(() => adminLayoutState.collapsed, (valor) => {
    try {
        localStorage.setItem(CHAVE_RECOLHIDA, valor ? '1' : '0');
    } catch {
        /* localStorage indisponível: a preferência só não sobrevive ao reload. */
    }
});

export function abrirSidebarMobile(): void {
    adminLayoutState.mobileOpen = true;
}

export function fecharSidebarMobile(): void {
    adminLayoutState.mobileOpen = false;
}

export function alternarSidebarRecolhida(): void {
    adminLayoutState.collapsed = !adminLayoutState.collapsed;
}

/** "Recolhida" de fato: a preferência só se aplica no desktop. */
export function sidebarRecolhidaEfetiva(): boolean {
    return adminLayoutState.collapsed && !adminLayoutState.isMobile;
}
